import React from'react';import styles from"./style";/**
 * @returns {JSX}
 */var NavDrawerDivider=function NavDrawerDivider(){return React.createElement("hr",{"aria-hidden":true,className:styles});};export default NavDrawerDivider;